import { render } from "./AddButton.vue?vue&type=template&id=226f5ada&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=226f5ada&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226f5ada"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/FirmwareComponents/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "226f5ada"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('226f5ada', __exports__)) {
    api.reload('226f5ada', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=226f5ada&scoped=true", () => {
    api.rerender('226f5ada', render)
  })

}


export default __exports__